// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletItem_container__VlC1X","line":"WalletItem_line__X8M_X","icon":"WalletItem_icon__Iw1CN","name":"WalletItem_name__nkJt_","connect":"WalletItem_connect__EGeHG"};